<main class="content-page">
  <section class="content-hero">
    <p class="content-kicker">{{ 'pages.contact.kicker' | translate }}</p>
    <h1>{{ 'pages.contact.title' | translate }}</h1>
    <p>{{ 'pages.contact.lead' | translate }}</p>
  </section>

  <section class="contact-layout">
    <div class="contact-cards">
      <article>
        <span>{{ 'pages.contact.addressLabel' | translate }}</span>
        <h2>{{ 'pages.contact.address' | translate }}</h2>
        <a
          href="https://www.google.com/maps/search/?api=1&query=1138%20Budapest%20Cserhalom%20utca%20Mura%20utca"
          target="_blank"
          rel="noopener"
        >
          {{ 'pages.contact.mapCta' | translate }}
        </a>
      </article>
      <article>
        <span>{{ 'pages.contact.phoneLabel' | translate }}</span>
        <h2><a href="tel:+36300121051">+36-30/012-1051</a></h2>
        <p>{{ 'pages.contact.phoneText' | translate }}</p>
      </article>
      <article>
        <span>{{ 'pages.contact.emailLabel' | translate }}</span>
        <h2><a href="mailto:twogetherflower@gmail.com">twogetherflower@gmail.com</a></h2>
        <p>{{ 'pages.contact.emailText' | translate }}</p>
      </article>
      <article>
        <span>{{ 'pages.contact.orderLabel' | translate }}</span>
        <h2>{{ 'pages.contact.orderTitle' | translate }}</h2>
        <p>{{ 'pages.contact.orderText' | translate }}</p>
        <div class="contact-order-actions">
          <a
            href="https://shop.twogetherflower.hu"
            target="_blank"
            rel="noopener"
          >
            {{ 'pages.shared.shop' | translate }}
          </a>
          <a
            href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
            target="_blank"
            rel="noopener"
          >
            {{ 'pages.shared.wolt' | translate }}
          </a>
        </div>
      </article>
    </div>

    <img src="assets/images/autumn-outside.jpg" [alt]="'pages.contact.imageAlt' | translate" />
  </section>
</main>
